const SEARCH_TERM_CHANGED = "SEARCH_TERM_CHANGED"

export { SEARCH_TERM_CHANGED }
